<template>
  <div>
    <el-form ref="form" label-width="80px">
      <p>
        <el-input v-model="card_num" class="login-input" placeholder="vip卡号" suffix-icon="el-icon-user" />
      </p>
      <p style="position: relative">
        <el-input v-model="password" class="login-input" show-password placeholder="请输入卡上密码" />
      </p>
      <div class="login_btn_ture" @click="login">确认</div>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: '',
  data() {
    return {
      card_num: "",
      password: "",
    };
  },


  methods: {
    ...mapMutations(["setInfo"]),
    login() {
      this.$fecth
        .post("users/login/login_card", {
          card_num: this.card_num,
          password: this.password,
        })
        .then((res) => {
          if (res) {
            localStorage.setItem("TOKEN", res.token);
            delete res.userInfo.profile;
            localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
            this.$notify({
              showClose: true,
              message: "恭喜你，登录成功！",
              type: "success",
            });


            this.setInfo(res.userInfo);
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
          }
        });
    },
  },

};
</script>


<style scoped lang='less'>
.title {
  color: #b3b3b3;
  font-size: 18px;
  vertical-align: middle;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #b3b3b3;

}

.login-input {
  margin-bottom: 20px;
}

.login_btn_ture {
  background: #12a0f3;
  line-height: 40px;
  color: white;
  text-align: center;
  letter-spacing: 3px;
  font-size: 16px;
  border-radius: 4px;
}

.getCode {
  height: 40px;
}

.bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  font-size: 16px;
  color: #b3b3b3;

  a {
    color: #b3b3b3;
  }
}
</style>
